/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

export default function detectAudioVideoStatus(callback) {
    detectWebcam(function (hasWebcam) {        
        if (hasWebcam) {          
          checkAudioVideoPermission(callback);
        } else {
          if (callback) {
            callback([false, null]);
          }
        }
    });
  }
  
  function detectWebcam(callback) {
    let md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) {
      if (callback) {
        return callback(false);
      }
      return
    }
    md.enumerateDevices().then(devices => {
      if (callback) {
        callback(devices?.some(device => 'videoinput' === device.kind));
      }
    })
  }

  function checkAudioVideoPermission(callback) {
    //var promise = navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    navigator.mediaDevices.getUserMedia({ audio: true, video: true })
      .then(function (stream) {
        /* use the stream */
        setTimeout(function () {
          stream.getTracks().forEach(track => {
            track.stop();
            if (callback) {
              callback([null, true]);
            }
          });
        }, 3000);
      })
      .catch(function (err) {        
        // setAudioVideoStatusModelOpen(true);
        if (callback) {
          callback([null, false]);
        }

        navigator.mediaDevices.getUserMedia({ audio: true, video: true })
          .then(stream => {
            // Code for success
            checkAudioVideoPermission();
          }).catch(err => {
            console.log("Not supported");            
          })
      });
  }
